import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { RatingTypeEnum } from 'types/api/enums'
import { GameZones } from 'types/global'

export const useGameZone = (): GameZones | undefined => {
  const ownProfile = useSelector((state: AppState) => state.profile.ownProfile)

  return useMemo(() => {
    if (!ownProfile || (!ownProfile.gameZoneSingles && !ownProfile.gameZoneDoubles))
      return undefined

    const { gameZoneSingles, wtnSinglesNumeric } = ownProfile
    // We currently show only the GameZone for Singles and only if the WTN is above 10
    const shouldShowGameZone = typeof wtnSinglesNumeric === 'number' && wtnSinglesNumeric > 10
    const gameZones = {
      [RatingTypeEnum.ITF]:
        shouldShowGameZone && gameZoneSingles
          ? {
              upper: gameZoneSingles.upper,
              lower: gameZoneSingles.lower,
            }
          : undefined,
    }

    return gameZones
  }, [ownProfile])
}
